import { useEffect, useRef, useState } from 'react'
import {
  getPolicies,
  getProfileImage,
  getRandomNickname,
  postCreateUser,
  postKakaoSocialLogin,
  postLogin,
  postUserPolicies,
} from '../../api/login'
import { InputCheckbox } from '../../components/input/InputCheckbox'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/Member.css'
import { PoliciesType } from '../../@types/aboutfishing'
import { detect } from 'detect-browser'
import { postOpenid } from '../../api/auth'
import { useNavigate } from 'react-router-dom'
import { handleAccessToken } from '../../js/script'

export default function SignAgree({
  setText,
  setDetailText,
  setPolicy,
  policy,
  authType,
  kakaoUserData,
  kakaoToken,
  email,
  phoneNumber,
  verificationCheckCode,
}: any) {
  const [isCheckboxSameOrder, setIsCheckboxSameOrder] = useState<boolean>(false) // 주문자 동일 체크박스 상태
  const [item, setItem] = useState<PoliciesType[]>([])
  const [allAgree, setAllAgree] = useState(false)
  const [agreeArray, setAgreeArray] = useState<any>([])
  const [selectAgreeRequire, setSelectAgreeRequire] = useState<any>([])
  const [require, setRequire] = useState<any>([])
  const [select, setSelect] = useState<string>('')
  const [os, setOs] = useState<string>('')
  const navigate = useNavigate()

  useEffect(() => {
    const browerOs = detect()
    setOs(browerOs?.os as string)
    getPolicies()
      .then((res) => {
        setItem(res.data)

        // 필수 정책 ID를 수집하기 위한 배열
        const requiredIds = res.data
          ?.filter((el: any) => el.isRequired) // 필수 정책만 필터링
          ?.map((el: any) => el.id) // ID만 추출
          ?.sort((a: number, b: number) => b - a) // 정렬

        setRequire(requiredIds) // 한 번의 상태 업데이트로 설정
      })
      .catch((err) => console.log(err))
  }, [])

  const arraysEqual = (a: any, b: any) => {
    if (a.length !== b.length) return false
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false
    }
    return true
  }
  useEffect(() => {
    if (require) {
      if (arraysEqual(require, selectAgreeRequire)) {
        setAllAgree(true)
      } else {
        setAllAgree(false)
      }
      if (agreeArray.length === item.length) {
        setIsCheckboxSameOrder(true)
      } else if (agreeArray.length !== item.length) {
        setIsCheckboxSameOrder(false)
      }
    }
  }, [agreeArray, require])

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  useEffect(() => {
    if (item) {
      const agreeArray: any = []
      item.map((el: any) => {
        const obj = { policyId: '', isAgreed: false }
        obj.policyId = el.id
        obj.isAgreed = false
        agreeArray.push(obj)
        setPolicy(agreeArray)
      })
    }
  }, [item])

  const nickName = async () => {
    const res = await getRandomNickname()
    return res.data
  }

  useEffect(() => {
    getProfileImage()
      .then((res) => {
        // 모든 이미지 URL을 추출하여 한 번에 상태 업데이트
        const urls = res.data.map((el: any) => el.png)
        getRandomElement(urls)
      })
      .catch((err) => console.log(err))
  }, [])

  function getRandomElement(arr: string[]) {
    // Math.random()을 사용하여 0과 배열의 길이 사이의 랜덤 인덱스를 생성합니다.
    const randomIndex = Math.floor(Math.random() * arr.length)
    setSelect(arr[randomIndex])
  }

  return (
    <>
      <PageTitle className='small' style={{ padding: '0 20px 12px' }}>
        약관동의
      </PageTitle>
      <div className='agree_warp'>
        <div className='f_wrap'>
          <div
            className='agree_all'
            onClick={() => {
              if (!allAgree) {
                const array: any = []
                const selectArray: any = []
                const agreeArray: any = []

                item.map((el: any) => {
                  const obj = { policyId: '', isAgreed: false }
                  array.push(el.id)
                  if (el.isRequired) {
                    selectArray.push(el.id)
                    selectArray.sort((a: number, b: number) => b - a)
                  }
                  obj.policyId = el.id
                  obj.isAgreed = true
                  agreeArray.push(obj)
                  setAgreeArray(array)
                  setSelectAgreeRequire(selectArray)
                  setPolicy(agreeArray)
                })
              } else {
                setAgreeArray([])
                setSelectAgreeRequire([])
                const agreeArray: any = []
                item.map((el: any) => {
                  const obj = { policyId: '', isAgreed: false }
                  obj.policyId = el.id
                  obj.isAgreed = false
                  agreeArray.push(obj)
                  setPolicy(agreeArray)
                })
              }
              setAllAgree((prev: boolean) => !prev)
            }}
          >
            <InputCheckbox
              text={'전체동의'} //이부분은 어케 할지 고민좀 해봐야할 것 같습니다.
              isCheckbox={isCheckboxSameOrder}
              setIsCheckbox={setIsCheckboxSameOrder}
              fontWeight={600}
            ></InputCheckbox>
          </div>
          <div className='agree_list'>
            {item.map((el: any) => {
              return (
                <AgreeList
                  el={el}
                  key={el.id}
                  setAgreeArray={setAgreeArray}
                  agreeArray={agreeArray}
                  setAllAgree={setAllAgree}
                  setDetailText={setDetailText}
                  setText={setText}
                  setSelectAgreeRequire={setSelectAgreeRequire}
                  selectAgreeRequire={selectAgreeRequire}
                  setPolicy={setPolicy}
                  policy={policy}
                ></AgreeList>
              )
            })}
          </div>
        </div>

        <div className='modal_footer'>
          <button
            type='button'
            className='btn_save'
            style={{
              width: '237px',
              margin: '26px auto 0',
              background: !allAgree ? 'var(--colGray2)' : 'var(--colBlack)',
              color: !allAgree ? 'var(--colGray4)' : 'var(--colWhite)',
            }}
            disabled={!allAgree}
            onClick={async () => {
              const randomNickname = await nickName()
              if (allAgree) {
                if (authType === 'kakao') {
                  postCreateUser(
                    kakaoUserData.kakao_account.email,
                    randomNickname,
                    kakaoUserData.kakao_account.phone_number.replace('+82 10-', '010-').replace(/-/g, ''),
                    null,
                    null,
                    os,
                    select,
                    false,
                    'kakao',
                    String(kakaoUserData.id)
                  )
                    .then((res) => {
                      postKakaoSocialLogin(
                        String(kakaoUserData.id),
                        kakaoToken,
                        kakaoUserData.kakao_account.phone_number.replace('+82 10-', '010-').replace(/-/g, '')
                      )
                        .then((res) => {
                          if (res.data.code === 'E0123') {
                            console.log(res.data)
                          } else if (res.data.code === 'E0127') {
                            alert('회원탈퇴 한지 7일이 지나지 않았습니다.')
                          } else if (res.data.code === 'E0125') {
                            alert('회원탈퇴 한지 180일이 지나지 않았습니다.')
                          } else if (res.data.code === 'E0111') {
                            navigate(`/sanctions`, {
                              state: { userData: res.data },
                            })
                          } else {
                            window.localStorage.setItem(`aboutRefreshToken`, JSON.stringify(res.data.refreshToken))
                            window.localStorage.setItem(`aboutAccessToken`, JSON.stringify(res.data.accessToken))
                            postUserPolicies(policy, res.data.accessToken)
                              .then((res) => {
                                console.log(res.data)
                              })
                              .catch((err) => {
                                console.log(err)
                              })
                            postOpenid(res.data.accessToken).then((response) => {
                              window.localStorage.setItem(`accessToken`, JSON.stringify(response.data.accessToken))
                              handleAccessToken()
                              setText('signUpCompleted')
                            })
                          }
                        })
                        .catch((err) => {
                          console.log(err)
                        })
                    })
                    .catch((err) => {
                      console.log(err)
                    })
                } else if (authType === 'mobile') {
                  postCreateUser(
                    email,
                    randomNickname,
                    phoneNumber,
                    null,
                    verificationCheckCode,
                    os,
                    select,
                    true,
                    'mobile',
                    email
                  )
                    .then((res) => {
                      console.log(res.data)
                      postLogin(phoneNumber, verificationCheckCode, os)
                        .then((res) => {
                          if (res.data.code === 'E0123') {
                            alert(res.data.code)
                          } else if (res.data.code === 'E0127') {
                            alert('회원탈퇴 한지 7일이 지나지 않았습니다.')
                          } else if (res.data.code === 'E0125') {
                            alert('회원탈퇴 한지 180일이 지나지 않았습니다.')
                          } else if (res.data.code === 'E0111') {
                            navigate(`/sanctions`, {
                              state: { userData: res.data },
                            })
                          } else {
                            window.localStorage.setItem(`aboutRefreshToken`, JSON.stringify(res.data.refreshToken))
                            window.localStorage.setItem(`aboutAccessToken`, JSON.stringify(res.data.accessToken))
                            postUserPolicies(policy, res.data.accessToken).catch((err) => {
                              console.log(err)
                            })
                            postOpenid(res.data.accessToken)
                              .then((res) => {
                                window.localStorage.setItem(`accessToken`, JSON.stringify(res.data.accessToken))
                                // closeModal();
                                handleAccessToken()
                                setText('signUpCompleted')
                              })
                              .catch((err) => console.log(err))
                          }
                        })
                        .catch((err) => console.log(err))
                    })
                    .catch((err) => {
                      console.log(err)
                    })
                } else {
                  setText('login')
                }
              }
            }}
          >
            동의하기
          </button>
        </div>
      </div>
    </>
  )
}

function AgreeList({
  el,
  setAgreeArray,
  agreeArray,
  setText,
  setAllAgree,
  setDetailText,
  setSelectAgreeRequire,
  selectAgreeRequire,
  setPolicy,
  policy,
}: any) {
  const [checked, setChecked] = useState(false)
  useEffect(() => {
    agreeArray.map((element: any) => {
      if (el.id === element) {
        setChecked(true)
      }
    })
    if (agreeArray.length === 0) {
      setChecked(false)
    }
  }, [agreeArray])

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  return (
    <div>
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '10px',
          width: '100%',
          cursor: 'pointer',
        }}
        onClick={() => {
          setChecked((prev: boolean) => !prev)
          const plusSelectarray: any = selectAgreeRequire

          if (!checked) {
            setAgreeArray((prev: any) => [...prev, el.id])
            const array: any = []
            policy.map((element: any) => {
              const obj = { policyId: '', isAgreed: false }
              if (element.policyId === el.id) {
                obj.policyId = element.policyId
                obj.isAgreed = true
                array.push(obj)
              } else {
                array.push(element)
              }
            })
            if (el.isRequired) {
              plusSelectarray.push(el.id)
              plusSelectarray.sort((a: number, b: number) => b - a)
            }
            setSelectAgreeRequire(plusSelectarray)
            setPolicy(array)
          } else {
            let array: any = []
            let selectArray: any = []
            agreeArray.map((element: any) => {
              if (element === el.id) {
                if (agreeArray.length === 1) {
                  array = []
                }
              } else {
                array.push(element)
              }
              setAgreeArray(array)
              setAllAgree(false)
            })
            const policyArray: any = []
            policy.map((element: any) => {
              const obj = { policyId: '', isAgreed: false }
              if (element.policyId === el.id) {
                obj.policyId = element.policyId
                obj.isAgreed = false
                policyArray.push(obj)
              } else {
                policyArray.push(element)
              }
            })
            setPolicy(policyArray)
            selectAgreeRequire.map((element: any) => {
              if (element === el.id) {
                if (selectAgreeRequire.length === 1) {
                  selectArray = []
                  setSelectAgreeRequire(selectArray)
                }
              } else {
                selectArray.push(element)
                selectArray.sort((a: number, b: number) => b - a)

                setSelectAgreeRequire(selectArray)
              }
            })
          }
        }}
      >
        {checked ? (
          <img src='/images/icon_checkbox2_true.svg' alt='checkbox' style={{ width: 20, height: 20 }}></img>
        ) : (
          <img src='/images/icon_checkbox2_false.svg' alt='checkbox' style={{ width: 20, height: 20 }}></img>
        )}
        <p
          style={{
            fontSize: '16px',
            width: '100%',
            fontWeight: '400',
            lineHeight: '20px',
            color: 'rgb(25, 25, 25)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div>
            {el.isRequired ? <span>(필수)</span> : <span>(선택)</span>}
            {el.title}
          </div>
          <button
            onClick={() => {
              if (el.id !== 10) {
                setText('agreeDetail')
                setDetailText(el.content)
              }
            }}
          >
            {el.title !== '만 14세 이상입니다.' ? <img src='../../images/icon_arrow_right_black.png' alt='' /> : null}
          </button>
        </p>
      </div>
    </div>
  )
}
